import {useContext} from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {SupplierMappingDetails} from '../../context'
import {useSearchParams} from 'react-router-dom'
const DeleteSupplierMappingModal = ({supplierMapping, onClose}: any) => {
  const {onDeleteProducts, isOperationLoading, isLoadingAllProducts, setCheckedRows} =
    useContext(SupplierMappingDetails)
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')

  const onDelete = async () => {
    await onDeleteProducts({
      emailId: id,
      productIds:
        supplierMapping?.productId?.length > 0
          ? supplierMapping?.productId
          : [supplierMapping?.productId],
    })
    setCheckedRows([])
    onClose()
  }

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      onAction={onDelete}
      isOperationLoading={isOperationLoading}
      isDataLoading={isLoadingAllProducts}
      body={
        <>
          <p className='mb-2'>Do you really want to remove this products from the mapping?</p>
          <p>This action is irreversible and will remove from the supplier mapping.</p>
        </>
      }
      actionName='Delete Mapping'
      actionBtnClass='btn-danger'
    />
  )
}

export default DeleteSupplierMappingModal
